import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChooseFormComponent } from './components/choose-form/choose-form.component';
import { RpkComponent } from './components/rpk/rpk.component';
import { AppGuard } from './app.guard';
import {SignComponent} from "./components/sign/sign.component";
import {LoginComponent} from "./components/login/login.component";
import {HomeComponent} from "./components/home/home.component";
import {ProposalsListComponent} from "./components/proposals-list/proposals-list.component";
import {ProposalSignedComponent} from "./components/proposal-signed/proposal-signed.component";
import {SignResponseComponent} from "./components/sign-response/sign-response.component";

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'choose-form', component: ChooseFormComponent, canActivate: [AppGuard]},
  { path: 'rpk', component: RpkComponent, canActivate: [AppGuard]},
  { path: 'sign', component: SignComponent, canActivate: [AppGuard]},
  { path: 'login', component: LoginComponent},
  { path: 'proposals-list', component: ProposalsListComponent, canActivate: [AppGuard]},
  { path: 'proposal-signed', component: ProposalSignedComponent, canActivate: [AppGuard]},
  { path: 'sign-response', component: SignResponseComponent, canActivate: [AppGuard]},
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
